import React from 'react'
import '../../../styles/onboardingStep1.css';
import { Button } from '@material-ui/core';
import { inject, observer } from 'mobx-react';
import { Redirect } from 'react-router-dom';
import { createBrowserHistory as createHistory } from 'history'

const history = createHistory()
const imagesPath = {
    unchecked: "https://projects.invisionapp.com/assets/16222444/249031932/8BD60C64EE967E2DAAE44CE863D04BB0FBB73757752F880C9F984465CD3539BF/thumbnail",
    checked: "https://projects.invisionapp.com/assets/16222444/249031942/9F6B0E9B146337960BEDDC77A9B0CEC6F7BC90A8B226A2440F2AC8E83B22B512/thumbnail"

}
@inject('userStore', 'navigatorStore', 'authStore')
@observer
export default class onboardingStep_1 extends React.Component {
    constructor() {
        super();

        this.state = {
            output: {
                interests: ""
            },
            buy: false,
            sell: false,
            browse: false,
            onboardingInProcess: true
        }
    }

    componentDidMount() {
        if (window.localStorage.hasOwnProperty("userData")) {
            this.props.userStore.pulluser()
                .then((response) => {
                    // console.log(response);
                    if (response.data[0].interests != null) {
                        this.setState({
                            userInterests: response.data[0].interests,
                            buy: (response.data[0].interests.includes("Buy") ? true : false),
                            sell: (response.data[0].interests.includes("Sell") ? true : false),
                            browse: (response.data[0].interests.includes("Browse") ? true : false),
                        })
                    }
                })
        }

        // this.backListener = history.listen(location => {
            // if (location.hash === "#/") {
                // Do your stuff
                // // console.log("popping", location)
                // this.setState({
                //     navToHome: true
                // })
            // }
        // });

        // window.onhashchange(){
        // }
    }

    wantsToBuy() {
        this.setState({
            buy: !this.state.buy,
        }, function () {
            // console.log(this.state.buy)

        })
    }

    wantsToSell() {
        this.setState({
            sell: !this.state.sell,
        }, function () {
            // console.log(this.state.sell)

        })
    }
    prevStep() {

    }
    wantsToBrowse() {
        this.setState({
            browse: !this.state.browse,
        }, function () {
            // console.log(this.state.browse)

        })
    }

    getImageNameBuy = () => this.state.buy ? 'checked' : 'unchecked'
    getImageNameSell = () => this.state.sell ? 'checked' : 'unchecked'
    getImageNameBrowse = () => this.state.browse ? 'checked' : 'unchecked'

    nextStep(item) {
        // if (!this.state.buy && !this.state.sell && !this.state.browse) {
        //     this.props.navigatorStore.openErrorModal("please choose your interest");
        //     return;
        // }

        let body = ""
        if (item === "next") {
            if (this.state.buy) {
                body = body.concat("Buy, ")
            }
            if (this.state.sell) {
                body = body.concat("Sell, ")
            }
            if (this.state.browse) {
                body = body.concat("Browse, ")
            }
            this.props.userStore.requestToEditUser(null, { interests: body.substring(0,body.lastIndexOf(",")) })
                .then((response) => {
                    // console.log(response)
                    this.setState({
                        onboardingInProcess: false
                    })
                })
            // console.log("[look body ]", body)
        }
        else {
            this.setState({
                onboardingInProcess: false
            })
        }
    }



    render() {

        const imageNameBuy = this.getImageNameBuy();
        const imageNameSell = this.getImageNameSell();
        const imageNameBrowse = this.getImageNameBrowse();

        if (this.state.onboardingInProcess)
            return (
                <div className="back">
                    <div className="heading-welcome">
                        WELCOME
                    <hr className="line-category-name margin-auto"></hr>
                    </div>
                    <div className="container onboardingStep1 onboarding-container">
                        <div className="content">
                            <div className="heading-text">
                                <div className="onboarding-question">
                                    What are your interests?
                                </div>
                                {/* <div className="onboarding-step-number">
                                    Step 1 of 3
                                </div> */}
                            </div>

                            <div className="buy-art">

                                <div className="step-block">
                                    <div className="para-heading" >
                                        Buy Art</div>
                                    <div className="para-content"> I want to buy art on the masterpieces platform.</div>
                                </div>
                                <div>
                                    <a onClick={this.wantsToBuy.bind(this)}>

                                        <img alt="" className="image-like" src={imagesPath[imageNameBuy]} onClick={this.wantsToBuy.bind(this)}></img>
                                    </a>
                                </div>
                            </div>

                            <div className="sell-art">

                                <div style={{ flex: 1, display: "flex", flexDirection: "column" }}>
                                    <h className="para-heading" >
                                        Sell Art</h>
                                    <p className="para-content"> I want to sell art on the masterpieces platform.</p>
                                </div>
                                <div>
                                    <a onClick={this.wantsToSell.bind(this)}>
                                        <img alt="" className="image-like" src={imagesPath[imageNameSell]}></img>
                                    </a>
                                </div>
                            </div>

                            <div className="browse-art">

                                <div style={{ flex: 1, display: "flex", flexDirection: "column" }}>
                                    <h className="para-heading" >
                                        Browse Art</h>
                                    <p className="para-content"> I want to browse art on the masterpieces platform.</p>
                                </div>
                                <div>
                                    <a onClick={this.wantsToBrowse.bind(this)}>
                                        <img alt="" className="image-like" src={imagesPath[imageNameBrowse]}></img>
                                    </a>
                                </div>
                            </div>
                            <div style={{ display: "flex", flex: 1, flexDirection: "column" }}>

                                {/* <InterestFields state={this.state} imagesPath={imagesPath} Interests={Interests} onClicking={this.handleClickingInterest.bind(this)} /> */}
                                <div className="row margin-25 mt-25">

                                    <div className="col-md-6 col-sm-6 col-xs-12 width-50 pull-left">
                                        {/* <Button className="masterpieces-secondary-buttons button-prev ml-0 step2-button-secondary" onClick={() => this.nextStep("skip")}>
                                            SKIP
                                    </Button> */}
                                    </div>

                                    <div className="col-md-6 col-sm-6 col-xs-12 width-50 pull-right">
                                        <Button className="masterpieces-primary-buttons step2-button-primary"
                                            onClick={() => this.nextStep("next")}>SAVE
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )
        if (!this.state.onboardingInProcess) {
            if (window.localStorage.hasOwnProperty("userData")) {

                // this.props.authStore.resetOnboardingStatuses("onboardingOneIncomplete")
                return (
                    <Redirect push to='/edit-profile' />
                )
            }
            else return (

                <Redirect push to='/' />
            )

        }
    }

}


// WEBPACK FOOTER //
// ./src/components/Home/onboarding/edit-interests.js